module.exports = __webpack_public_path__ + "img/flag-icon.a64c9767.svg";